import React, { useState } from 'react';

const StageImageThumbnail = ({ imageUrl, altText, onClick }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
  const handleImageLoad = () => {
    setImageLoaded(true);
  };
  
  const handleImageError = () => {
    setHasError(true);
  };
  
  if (hasError) {
    return (
      <div className="pixel-stage-image-container" onClick={onClick}>
        <div className="pixel-image-error">Image not available</div>
      </div>
    );
  }
  
  return (
    <div 
      className="pixel-stage-image-container" 
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      {!imageLoaded && <div className="pixel-image-loading">Loading...</div>}
      <div className="pixel-image-crop-container">
        <img
          src={imageUrl}
          alt={altText}
          className="pixel-stage-image-cropped"
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ display: imageLoaded ? 'block' : 'none' }}
        />
      </div>
      <div className="pixel-image-zoom-hint">Click to view full image</div>
    </div>
  );
};

export default StageImageThumbnail;